<div class="board-mini" xmlns:v-on="http://www.w3.org/1999/xhtml">
    <div class="board-mini__block">
        <label v-on:click="toggleOpenRightMenu" for="input--layout--sidebar-right" class="pointer"><span class="icon chevrons"></span></label>
        <div v-if="title" class="title h4" v-html="title"></div>
    </div>
    <div v-if="subtitle" class="subtitle">{{ subtitle }}</div>
</div>
